import React, {useEffect, useState} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';

const useStyles = makeStyles({
  root: {
    width: 300,
  },
});

function valuetext(value) {
  return `${value}°C`;
}

export default function RangeSlider({ name, label, value, onChange, ...props }) {
  const classes = useStyles();
  const [val, setVal] = useState(value);

  useEffect(() => {
    if (value !== val) {
      setVal(value);
    }
  }, [value]);

  const handleChange = (event, newValue) => {
    onChange({
      target: {
        name,
        value: newValue,
      },
    });
  };

  const valueFormatter = props.valueLabelFormat || ((val) => val);

  const formatValue = () => {
    if (val && val.length === 2) {
      return `- ${valueFormatter(val[0])} - ${valueFormatter(val[1])}`;
    }
    return '';
  };

  return (
    <div className={classes.root}>
      <Typography gutterBottom>
        {label} {formatValue()}
      </Typography>
      <Slider
        value={val}
        onChange={(e, v) => setVal(v)}
        onChangeCommitted={handleChange}
        valueLabelDisplay="off"
        getAriaValueText={valuetext}
        valueLabelFormat={valueFormatter}
        {...props}
      />
    </div>
  );
}